import { styled as e, Box as x, Typography as a } from "@mui/material";
import h from "./MuiCheckbox.js";
import * as d from "ramda";
import { useId as m } from "react";
import { jsxs as l, jsx as r } from "react/jsx-runtime";
const b = e(x)`
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: center;
`, u = e(h)`
  border: 1px solid #838383;
  border-radius: 3px;
  background-color: #363636;
  height: 20px;
  width: 20px;
  &.Mui-checked > .Checkbox-iconGroup {
    border: unset;
  }
  &.MuiCheckbox-root {
    margin-top: 2px;
  }
`, f = e(a)`
  color: #838383;
  width: 100%;
  ${(o) => o.theme.breakpoints.up("res1280")} {
    font-size: 16px;
    line-height: 26px;
    max-width: 600px;
  }
  ${(o) => o.theme.breakpoints.down("res1280")} {
    font-size: 12px;
    line-height: 18px;
    max-width: 250px;
  }
`, y = (o) => {
  const {
    checked: t,
    className: s,
    description: n,
    disabled: p,
    onChange: c
  } = o, i = m();
  return /* @__PURE__ */ l(b, {
    className: s,
    children: [/* @__PURE__ */ r(u, {
      id: i,
      className: "Custom-Checkbox",
      disabled: p,
      onChange: c,
      ...d.isNotNil(t) ? {
        checked: t
      } : {}
    }), /* @__PURE__ */ r(f, {
      className: "Custom-Description",
      component: "label",
      htmlFor: i,
      children: n
    })]
  });
};
export {
  y as default
};
//# sourceMappingURL=ApeironCheckbox.js.map
